import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';

import * as $ from 'jquery';
import {
    CreateExternalLocationCommand, HighestRiskCalculationType, LocationItem,
    LocationSearchOrder, LocationSearchType, RiskAssessmentStatus
} from 'src/app/contracts';
import { LocationService, NotificationService } from 'src/app/services';

@Component({
    selector: 'app-external-location-overview',
    templateUrl: './external-location-overview.component.html',
    styleUrls: ['./external-location-overview.component.css']
})
export class ExternalLocationOverviewComponent implements OnInit, AfterViewInit {
    public riskAssessmentStatus = RiskAssessmentStatus; // Make enum accessible from the html-template
    public highestRiskCalculationType = HighestRiskCalculationType;

    public hasLocations = false;
    public searchResults: Array<LocationItem>;
    public hasSearched = false;

    // New location
    public newLocationNumber: string;
    public newLocationName: string;
    public newLocationErrorMsg: string;
    public userInfo: any;

    public searchText = '';
    public orderBy = LocationSearchOrder.RiskassessmentFactor;
    public orderDescending = true;
    public continuationToken = '';

    constructor(
        private readonly notificationService: NotificationService,
        private readonly locationService: LocationService,
        private readonly cdref: ChangeDetectorRef) {

    }

    public ngOnInit(): void {
    }

    public ngAfterViewInit(): void {
        this.onSearch();
        this.cdref.detectChanges();
    }

    public openCreateLocation(): void {
        this.newLocationName = '';
        this.newLocationNumber = '';
        this.newLocationErrorMsg = '';
    }

    public createLocation(): void {
        if (!this.newLocationNumber || !this.newLocationName) {
            return;
        }

        this.notificationService.showLoader();

        const command: CreateExternalLocationCommand = {
            number: this.newLocationNumber,
            name: this.newLocationName
        };

        // Checking locationNumber requires uniqueness within the cvr (organization).
        // This should be checked from server when comitting the new location
        this.locationService.createLocation(command).subscribe(
            (res) => {
                this.onSearch();
                this.closeCreateLocationForm();
                this.notificationService.hideLoader();
            }, (res) => {
                this.newLocationErrorMsg = res.error;
                this.notificationService.hideLoader();
            });
    }

    public closeCreateLocationForm(): void {
        const modal = $('#modalCloseButton');
        modal.click();

        this.openCreateLocation();
    }

    public onKeydown(event): void {
        this.onSearch();
    }

    public onSearch(): void {
        this.notificationService.showLoader();
        const criteria = {
            searchText: this.searchText,
            caseWorkerName: '',
            riskAssessmentStatus: null,
            calculationType: null,
            searchType: LocationSearchType.External,
            orderBy: this.orderBy,
            orderDescending: this.orderDescending,
            continuationToken: this.continuationToken
        };

        this.locationService.search(criteria).subscribe(
            (res) => {
                this.hasSearched = true;
                this.searchResults = res.items;
                this.continuationToken = res.continuationToken;
                this.hasLocations = res.items.length > 0;
                this.notificationService.hideLoader();
            }, (res) => {
                this.notificationService.hideLoader();
            });
    }
}
